import React from 'react';
import {
    Box,
    Paper,
} from '@mui/material';
import {useDispatch} from 'react-redux';
import {useToken} from '../../../hooks/useToken';
import InfiniteScroller from '../../../shared/components/ui/InfiniteScroller/InfiniteScroller'; // Tu componente de scroll
import CardContactMobile from "./CardContactMobile";
import {getListContacts, getListContactsByName} from "../../../actions/contacts/contacts";

const TableContactsBodyMobile = ({id_customer, searcher, resetCounter, setLoading = () => {}}) => {
    const dispatch = useDispatch();
    const {getTokenSilent} = useToken();

    const fetchContacts = async (offset) => {
        setLoading(true);
        try {
            const token = await getTokenSilent();

            if (searcher && validarLongitud(searcher)) {
                const response = await dispatch(getListContactsByName(searcher, id_customer, token, offset, 20));
                return response?.items?.map(item => ({...item, __offset: offset})) || [];
            }

            const response = await dispatch(getListContacts(id_customer, token, offset, 20));
            return response?.items?.map(item => ({...item, __offset: offset})) || [];
        } finally {
            setLoading(false);
        }
    };

    const validarLongitud = (valor) => {
        const longitud = valor.length;
        return longitud >= 4 && longitud <= 13;
    };

    return (
        <Box key={resetCounter} sx={{width: '100%'}}>
            <Paper sx={{width: '100%', mb: 2, overflow: 'hidden'}}>
                <InfiniteScroller
                    fetchItems={fetchContacts}
                    pageSize={20}
                    maxItems={100}
                    itemHeight={200}
                    itemsPerRow={1}
                    renderKey={(row) => row._id}
                    renderItem={(row) => <CardContactMobile contact={row}/>}
                />
            </Paper>
        </Box>

    );
};

export default TableContactsBodyMobile;
